import { api } from './client.js';

const root = '/admin/security';

export const securityApi = {
  listBans: () => api.get(`${root}/bans`),
  banIp: (body) => api.post(`${root}/bans`, body),
  unbanIp: (ip) => api.delete(`${root}/bans/${encodeURIComponent(ip)}`)
};
